// Input.js
import React, { useState } from "react";
import PropTypes from "prop-types";

const Input = ({
  type = "text",
  placeholder = "",
  label = "",
  startIcon,
  endIcon,
  isFullWidth = false,
  onEndIconClick,
  infoIconAsEnd = false, // New prop to use info icon as end icon
  infoText = "",
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const baseClasses = "flex items-center px-3 py-3 border rounded-md text-sm";
  const activeClasses = isFocused
    ? "border-agPrimary shadow-outline-agPrimary"
    : "border-agGray";
  const widthClass = isFullWidth ? "w-full" : "w-auto";
  const inputBaseClasses =
    "flex-1 focus:outline-none bg-transparent text-agBlack";
  const tooltipPosition =
    label || infoIconAsEnd ? "top-12 right-0" : "top-2 right-0";

  return (
    <div className={`relative flex flex-col ${widthClass} mb-4`}>
      {/* <div className={`relative flex flex-col ${widthClass}`}> */}
      {label && (
        <div className="flex justify-between items-center mb-1">
          <label className="text-sm font-medium text-agBlack">{label}</label>
          {!infoIconAsEnd && infoText && (
            <span
              className="material-icons-round text-agLightGray text-lg cursor-pointer"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              info
            </span>
          )}
        </div>
      )}
      <div className={`flex items-center ${baseClasses} ${activeClasses}`}>
        {startIcon && (
          <span className="material-icons-round mr-2 text-agPrimaryLight">
            {startIcon}
          </span>
        )}
        <input
          type={type}
          placeholder={placeholder}
          className={inputBaseClasses}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          {...props}
        />
        {endIcon && (
          <span
            className="material-icons-round ml-2 cursor-pointer text-agPrimaryLight"
            onClick={onEndIconClick}
          >
            {endIcon}
          </span>
        )}
        {infoIconAsEnd && infoText && (
          <span
            className="material-icons-round ml-2 cursor-pointer text-agLightGray text-lg"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            info
          </span>
        )}
      </div>
      {showTooltip && (
        <div
          className={`absolute bg-white rounded-md tooltip-card p-3 text-xs text-agLightGray  w-64 z-10 ${tooltipPosition}`}
        >
          {infoText}
        </div>
      )}
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  infoIconAsEnd: PropTypes.bool, // New prop for using info icon as end icon
  isFullWidth: PropTypes.bool,
  onEndIconClick: PropTypes.func,
  infoText: PropTypes.string,
};

export default Input;
